import { useEffect, useRef } from 'react';
import { WbAccordion, WbAccordionItem } from '@workbench/react';

/**
 * Controlled accordion mirroring the antd `Collapse` API used across the VIMDT
 * feature: `activeKeys` holds the open item keys, `onChange` receives the next set.
 */
function VimdtAccordion({ items, activeKeys = [], onChange, className, theme }) {
	// Several items can emit open/close in the same tick, so accumulate on the last
	// value we produced instead of the (then stale) `activeKeys` render snapshot.
	const pendingKeys = useRef(activeKeys);

	useEffect(() => {
		pendingKeys.current = activeKeys;
	}, [activeKeys]);

	const toggle = (key, open) => {
		if (!onChange) return;
		const { current } = pendingKeys;
		const isOpen = current.includes(key);
		if (open === isOpen) return;

		const next = open ? [...current, key] : current.filter((k) => k !== key);
		pendingKeys.current = next;
		onChange(next);
	};

	return (
		<WbAccordion className={className} theme={theme}>
			{items.map(({ key, header, content }) => (
				<WbAccordionItem
					key={key}
					open={activeKeys.includes(key) || undefined}
					onWbopen={() => toggle(key, true)}
					onWbclose={() => toggle(key, false)}
				>
					<span slot="header">{header}</span>
					<div slot="content">{content}</div>
				</WbAccordionItem>
			))}
		</WbAccordion>
	);
}

export default VimdtAccordion;
